<ng-container *ngIf="!hideArchivedCategories || node.isActive !== false || node.sourceId || node.sourceName">
  <li class="tree-item" [class.has-source]="hasSourceName()">
    <div
      class="tree-node px-1 py-2 m-0"
      
      [class.clickable]="hasChildren() || hasSourceName()"
      [class.source-expanded]="showSourceInfo"
      [class.selected]="isSelected()"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex w-100 align-items-center " (click)="onNodeClick()" [attr.data-testid]="'report-type-editor-item-on-node-click-' + node.id">
          <div class="flex-grow-1" [class]="'nest-level-' + nestingLevel">
            <!-- Icon based on node type -->
            <span class="mr-2 fa" 
                  [ngClass]="{
                    'fa-light fa-grid': nestingLevel === 0 && hasChildren(),
                    'fa-light fa-chart-line-up': nestingLevel > 0 && hasChildren(),
                    'fa-light fa-chart-column': hasSourceName() && node.sourceId === reportSources.Telerik,
                    'fa-light fa-chart-simple': hasSourceName() && node.sourceId === reportSources.PowerBI,
                    'fa-light fa-link': hasSourceName() &&  node.sourceId === reportSources.ExternalLink,
                    'fa-file-text-o': hasSourceName() && node.sourceId !== reportSources.Telerik && node.sourceId !== reportSources.PowerBI && node.sourceId !== reportSources.ExternalLink,
                    'fa-folder': !hasChildren() && !hasSourceName()
                  }"></span>
          
          <!-- Node name -->
          <span
            class="node-name" [title]="node.tooltipDescription ? node.tooltipDescription : ''"
            [ngClass]="{ 'text-warning': !node.sourceId && node.isActive === false }"
          >
            {{ node.name }}
          </span>
        
        </div>
        
        <!-- Expand/collapse indicator and actions -->
        <div class="text-right ml-2 d-flex align-items-center">
          <span *ngIf="hasChildren() && isExpanded" class="fa fa-angle-up"></span>
          <span *ngIf="hasChildren() && !isExpanded" class="fa fa-angle-down"></span>
        </div>
      </div>
      <div>
        <div *ngIf="!node.sourceId" class="d-flex mt-1">
          <i class="fa-light fa-pen-to-square" role="button" title="Edit Category" (click)="onEditCategoryClick()" *ngIf="node.isActive" [attr.data-testid]="'report-type-editor-item-edit-category-' + node.id"></i>
          <i class="fa-light fa-plus ml-3" role="button" title="Add Category" (click)="onAddCategoryClick()" *ngIf="node.isActive" [attr.data-testid]="'report-type-editor-item-add-category-' + node.id"></i>
          <i class="fa-light fa-box-archive ml-3" role="button" title="Archive Category" (click)="onToggleCategoryActiveClick()" [attr.data-testid]="'report-type-editor-item-archive-category-' + node.id"></i>
        </div>
        <div *ngIf="node.sourceId" class="d-flex mt-1">
          <i class="fa-light fa-clone" role="button" title="Duplicate Report" (click)="duplicateNode()" [attr.data-testid]="'report-type-editor-item-duplicate-report-' + node.id"></i>
        </div>
      </div>
    </div>
  </div>

</li>

<!-- Children -->
<ng-container *ngIf="hasChildren() && isExpanded">
  <ul class="tree-children px-1 py-0 m-0">
    <app-report-type-editor-item
      *ngFor="let child of node.children"
      [node]="child"
      [nestingLevel]="nestingLevel + 1"
      [selectedNode]="selectedNode"
      [expandFavorites]="expandFavorites"
      [hideArchivedCategories]="hideArchivedCategories"
      (nodeClick)="onChildNodeClick($event)"
      (openNewCategoryModal)="onChildAddCategoryClick($event)"
      (openEditCategoryModal)="onChildEditCategoryClick($event)"
      (toggleCategoryActive)="toggleCategoryActive.emit($event)"
      (duplicateReportType)="onChildDuplicateReportType($event)"
      [attr.data-testid]="'report-type-editor-item-child-' + child.id"></app-report-type-editor-item>
  </ul>
</ng-container>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/report-type-editor/report-type-editor-item/report-type-editor-item.component.html